export default function isEmptyDeep(obj: any, deathCounter = 0): boolean {
  if (typeof obj === 'boolean') return true; // If it is a boolean, both values should be accepted
  if (obj === 'UNKNOWN') return false; // A string with UNKNOWN should also be considered empty.
  if (!obj) return false;
  if (Array.isArray(obj)) {
    if (!obj.length) {
      return false;
    }
  }
  if (typeof obj === 'object') {
    if (deathCounter > 100) return true;
    return Object.values(obj).every((value) => !isEmptyDeep(value, deathCounter++));
  }
  return true;
}
